<div class="tw-flex tw-items-center tw-justify-center">
  <ul class="m-0" *ngIf="!loading">
    <li
      *ngFor="let item of items"
      class="payment-gateway-item"
      [attr.data-gateway-id]="item.id"
      (click)="onSelect(item)"
      [style.width.px]="itemSize"
    >
      <img
        [src]="getIconSrc(item?.typeIpg)"
        class="img img-thumbnail rounded"
        [width]="imageSize"
      />
      <span>{{ TypeIpGsDisplay[item?.typeIpg] | translate }}</span>
    </li>
  </ul>

  <ng-container *ngIf="loading">
    <div class="tw-px-1 tw-flex-center">
      <span
        class="text-primary spinner-border spinner-border"
        role="status"
        aria-hidden="true"
      ></span>
      <span class="sr-only">Loading...</span>
    </div>
  </ng-container>
</div>
